// extracted by mini-css-extract-plugin
module.exports = {"tabs":"TabsList_tabs__kpDtw","tabItem":"TabsList_tabItem__NF6tp","active":"TabsList_active__QvwY4"};